import EventEmitter from 'eventemitter3';

export default class DateFixedManager extends EventEmitter {

    _styleConsole = 'background: #222; color: #ff8c8c';
    _classes = {
        container: '',
        dateProjectItem: 'js-date-project-item',
        dateFixedContainer: 'js-date-fixed-container',
        dateFiguresContainer : 'js-date-figures-container',
        figuresItem : 'js-date-figure-item',
        initLoad: 'anim-init-load'
    };
    _date = {
        old: 0,
        current: 0,
        next: 0
    }

    constructor() {
        super();

        this._retrieveDOM();
        this.bind();
    }

    _retrieveDOM() {

        this._views = {};

        this._views.dateProjectItem = [].slice.call( document.body.querySelectorAll( '.' + this._classes.dateProjectItem ) );

        this._views.dateFixed = {
            container : document.body.querySelector( '.' + this._classes.dateFixedContainer ),
            figuresContainer : null,
            figuresItem: []
        };
        this._views.dateFixed.figuresContainer = this._views.dateFixed.container.querySelectorAll( '.' + this._classes.dateFiguresContainer );

        for( let i = 0, j = this._views.dateFixed.figuresContainer.length; i < j; i++ ) {
            this._views.dateFixed.figuresItem.push(
                this._views.dateFixed.figuresContainer[i].querySelectorAll( '.' + this._classes.figuresItem )
            );
        }

        this._initDataDOM();
    }

    _initDataDOM() {
        this._dateProjectLength = this._views.dateProjectItem.length;

        this._datesSplit = [];
        for( let i = 0, j = this._dateProjectLength; i < j; i++ ) {
            this._datesSplit.push(
               this._views.dateProjectItem[i].dataset.date.split('').map(Number)
            );
        }
    }

    bind() {
        //
        // window.addEventListener("load", (event) => {
        //     this._initClass();
        // });
    }

    _initClass() {
        this._setDate();
    }

    initLoad() {
        this._views.dateFixed.container.classList.remove( this._classes.initLoad );
    }

    _setDate() {
        for( let i = 0, j = this._datesSplit[ this._date.current ].length; i < j; i++ ) {
            let dateFigure = this._datesSplit[ this._date.current ][ i ];
            let currentfiguresItem = this._views.dateFixed.figuresItem[ i ][ dateFigure ];

            currentfiguresItem.style.transform = "translateY(0)";
        }

        // console.log(this._date.current);
        // console.log(this._datesSplit[ this._date.current ]);
    }

    setIndex( index ) {
        this._date = index;
    }

    _updateDate( direction ) {

        // console.log(this._date);
        // console.log(this._datesSplit[ this._date.current ]);

        let operator = ( direction == 'prev' ) ? 1 : -1;

        for( let i = 0, j = this._datesSplit[ this._date.current ].length; i < j; i++ ) {
            let dateFigure = this._datesSplit[ this._date.current ][ i ];
            let currentfiguresItem = this._views.dateFixed.figuresItem[ i ][ dateFigure ];

            let oldDateFigure = this._datesSplit[ this._date.old ][ i ];
            if( dateFigure != oldDateFigure ) {
                let oldFiguresItem = this._views.dateFixed.figuresItem[ i ][ oldDateFigure ];

                TweenMax.to(oldFiguresItem, 0.6, {y: operator * 100+'%', ease: Power2.easeOut});
                TweenMax.fromTo(currentfiguresItem, 0.6,{y: -operator * 100+'%' }, {y: '0%', ease: Power2.easeOut});
            }
        }
    }

    show() {
        this._views.dateFixed.container.classList.remove('hide');
    }

    hide() {
        this._views.dateFixed.container.classList.add('hide');
    }
}


// WEBPACK FOOTER //
// ./src/js/pages/history/modules/date-fixed-manager.js